
window.initResponsiveCarousels = function () {
    document.querySelectorAll('.modal-content.cro_addedcart_popup .product_wrapper.js-carousel').forEach(function (elem) {
        const cards = elem.querySelectorAll('.cro_product_card');
        if (typeof Flickity === 'undefined') {
            //console.error('Flickity is not loaded');
            return;
        }
        // Destroy existing Flickity instance if it exists
        if (elem.flickityInstance) {
            elem.flickityInstance.destroy();
            elem.flickityInstance = null;
        }

        const width = window.innerWidth;
        let groupCells = 1;
        let minCardsRequired = 2;
        let cellAlign = 0.45;

        if (width > 1024) {
            groupCells = 3;
            minCardsRequired = 4;
        } else if (width > 768) {
            groupCells = 2;
            minCardsRequired = 3;
        }

        if (width > 767) cellAlign = 'left';

        if (cards.length >= minCardsRequired) {
            const flkty = new Flickity(elem, {
                cellAlign: cellAlign,
                contain: true,
                pageDots: false,
                wrapAround: true,
                prevNextButtons: false,
                // groupCells: groupCells
            });

            elem.classList.remove('no-carousel'); // Ensure the fallback class is removed
            elem.flickityInstance = flkty;        // Save the Flickity instance

            const navContainer = elem.nextElementSibling;
            const dotsContainer = navContainer.querySelector('.custom-dots');
            dotsContainer.innerHTML = '';

            flkty.slides.forEach((slide, index) => {
                const dot = document.createElement('button');
                dot.classList.add('dot');
                dot.dataset.index = index;
                dotsContainer.appendChild(dot);
                dot.addEventListener('click', () => flkty.select(index));
            });

            const updateActiveDot = (index) => {
                dotsContainer.querySelectorAll('.dot').forEach((dot, i) => {
                    dot.classList.toggle('is-selected', i === index);
                });
            };

            requestAnimationFrame(() => {
                updateActiveDot(flkty.selectedIndex);
            });

            flkty.on('change', index => {
                updateActiveDot(index);
            });

            navContainer.querySelector('.arrow-prev').addEventListener('click', () => flkty.previous());
            navContainer.querySelector('.arrow-next').addEventListener('click', () => flkty.next());
        } else {
            elem.classList.add('no-carousel'); // Add fallback class when slider isn't initialized
        }
    });
}
let popupContainer = document.querySelector(".cro_addedcart_popup");
if (popupContainer) {
    //console.log("popupContainerpopupContainer")
    const array_for_freeshipping_99_custom = ['Czechia', 'Estonia', 'Hungary', 'Luxembourg', 'Slovakia', 'Monaco', 'Spain'];
    const array_for_freeshipping_49_custom = ['Germany', 'Netherlands', 'Belgium', 'Sweden', 'France', 'Denmark', 'Italy', 'Finland', 'Austria', 'Ireland', 'Switzerland', 'Poland', 'Portugal'];
    const array_for_freeshipping_42_custom = ['United Kingdom']
    // Detect country and cart data
    const countryData = window.jimmyjoy?.country_data?.detected_values;
    const cartData = window.jimmyjoy?.cart;
    /*
    console.log(countryData, "countryData")
    console.log(cartData, "cartData")
    */

    if (!countryData || !cartData) {
        console.warn('Missing country or cart data');
    } else {
        const countryName = countryData.country_name;
        const cartTotalCents = Number(cartData.total_price) || 0;
        let cartTotalEuros = cartTotalCents / 100;
        if (countryName === "United Kingdom" && cartData.currency !== "GBP") {
            const EUR_TO_GBP = 0.885;
            cartTotalEuros = cartTotalEuros * EUR_TO_GBP;
        }

        let FREE_SHIPPING_THRESHOLD_CUSTOM;

        if (array_for_freeshipping_99_custom.includes(countryName)) {
            FREE_SHIPPING_THRESHOLD_CUSTOM = 99;
        } else if (array_for_freeshipping_49_custom.includes(countryName)) {
            FREE_SHIPPING_THRESHOLD_CUSTOM = 49;
        } else if (array_for_freeshipping_42_custom.includes(countryName)) {
            FREE_SHIPPING_THRESHOLD_CUSTOM = 42;
        }
        //console.log(FREE_SHIPPING_THRESHOLD_CUSTOM, "FREE_SHIPPING_THRESHOLD_CUSTOM")
        // Only call update if country is in either list
        if (FREE_SHIPPING_THRESHOLD_CUSTOM !== undefined) {
            //console.log("funccall")
            updateFreeShippingBar(cartTotalEuros, FREE_SHIPPING_THRESHOLD_CUSTOM);
        } else {
            //console.log('Country not eligible for free shipping threshold');
        }
    }

    // Your update function (assuming defined somewhere)
    function updateFreeShippingBar(total, threshold) {
        //console.log("insidefun")
        const fill = document.querySelector('.cro_addedcart_popup .progress-fill');
        const message = document.querySelector('.cro_addedcart_popup .shipping-message');

        const progress = Math.min((total / threshold) * 100, 100);
        fill.style.width = `${progress}%`;

        const remaining = threshold - total;

        if (remaining > 0) {
            //console.log("window.currentPath", window.currentPath)
            if (window.currentPath == "nl") {
                message.textContent = `Besteed nog €${remaining.toFixed(2)} voor gratis verzending!`;
            } else if (window.currentPath == "de") {
                message.textContent = `Noch €${remaining.toFixed(2)} für gratis Versand!`;
            } else if (window.currentPath == 'en-gb') {
                message.textContent = `Spend £${remaining.toFixed(2)} to get free shipping!`;
            } else {
                message.textContent = `Spend €${remaining.toFixed(2)} to get free shipping!`;
            }
        } else {
            //console.log("window.currentPath", window.currentPath)
            if (window.currentPath == "nl") {
                message.textContent = `Je hebt gratis verzending!`;
            } else if (window.currentPath == "de") {
                message.textContent = `Gute Neuigkeiten! Du erhältst GRATIS VERSAND!`;
            } else {
                message.textContent = `Good news! You get FREE SHIPPING!`;
            }
        }
        document.querySelector(".free-shipping-bar").style.display = "block";
    }
} else {
    // console.warn('Popup container not found');
}
function equalizeCarouselHeights() {
    const cards = document.querySelectorAll('.carousel-cell .cro_product_card');
    let maxHeight = 0;

    cards.forEach(card => {
        card.style.height = 'auto'; // reset first
        if (card.offsetHeight > maxHeight) {
            maxHeight = card.offsetHeight;
        }
    });

    cards.forEach(card => {
        card.style.height = maxHeight + 'px';
    });
}

window.addEventListener('load', equalizeCarouselHeights);
window.addEventListener('resize', equalizeCarouselHeights);



function initResponsiveCarousels() {
    document.querySelectorAll('.product_wrapper.js-carousel').forEach(function (elem) {
        const cards = elem.querySelectorAll('.cro_product_card');

        // Destroy existing Flickity instance if it exists
        if (elem.flickityInstance) {
            elem.flickityInstance.destroy();
            elem.flickityInstance = null;
        }

        const width = window.innerWidth;
        let groupCells = 1;
        let minCardsRequired = 2;
        let cellAlign = 0.45;

        if (width > 1024) {
            groupCells = 3;
            minCardsRequired = 4;
        } else if (width > 768) {
            groupCells = 2;
            minCardsRequired = 3;
        }

        if (width > 767) cellAlign = 'left';

        if (cards.length >= minCardsRequired) {
            const flkty = new Flickity(elem, {
                cellAlign: cellAlign,
                contain: true,
                pageDots: false,
                wrapAround: true,
                prevNextButtons: false,
                // groupCells: groupCells
            });

            elem.classList.remove('no-carousel'); // Ensure the fallback class is removed
            elem.flickityInstance = flkty;        // Save the Flickity instance

            const navContainer = elem.nextElementSibling;
            const dotsContainer = navContainer.querySelector('.custom-dots');
            dotsContainer.innerHTML = '';

            flkty.slides.forEach((slide, index) => {
                const dot = document.createElement('button');
                dot.classList.add('dot');
                dot.dataset.index = index;
                dotsContainer.appendChild(dot);
                dot.addEventListener('click', () => flkty.select(index));
            });

            const updateActiveDot = (index) => {
                dotsContainer.querySelectorAll('.dot').forEach((dot, i) => {
                    dot.classList.toggle('is-selected', i === index);
                });
            };

            requestAnimationFrame(() => {
                updateActiveDot(flkty.selectedIndex);
            });

            flkty.on('change', index => {
                updateActiveDot(index);
            });

            navContainer.querySelector('.arrow-prev').addEventListener('click', () => flkty.previous());
            navContainer.querySelector('.arrow-next').addEventListener('click', () => flkty.next());
        } else {
            elem.classList.add('no-carousel'); // Add fallback class when slider isn't initialized
        }
    });
}

// Initial run
initResponsiveCarousels();

// Run on resize, with debounce
let resizeTimeout;
window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
        initResponsiveCarousels();
    }, 200);
});


document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        initResponsiveCarousels();
        equalizeCarouselHeights();
    }, 500); // slight delay to allow DOM to stabilize
});
// window.addCartFromPopup = function () {
//     document.querySelectorAll('.cro_add_to_cart_btn').forEach(button => {
//         button.addEventListener('click', function () {
//             const variantId = this.dataset.variantId;
//             const productId =  this.dataset.productid;
//             console.log(productId,"this.dataset",variantId,"variantId")
//             if (!variantId) return;

//             fetch('/cart/add.js', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     quantity: 1,
//                     id: variantId
//                 })
//             })
//                 .then(response => {
//                     if (!response.ok) throw new Error('Add to cart failed');
//                     return response.json();
//                 })
//                 .then(data => {
//                     // ✅ Redirect to cart page after successful add
//                     if (window.currentPath == "nl") {
//                         window.location.href = '/nl/cart';
//                     } else if (window.currentPath == "de") {
//                         window.location.href = '/de/cart';
//                     } else {
//                         window.location.href = '/cart';
//                     }
//                 })
//                 .catch(error => {
//                     console.error('Error adding to cart:', error);
//                 });
//         });
//     });
// }

// window.addCartFromPopup();

window.addCartFromPopup = function () {
    document.querySelectorAll('.cro_add_to_cart_btn').forEach(button => {
        button.addEventListener('click', async function () {

            const variantId = Number(this.dataset.variantId);
            const productId = this.dataset.productid;

            if (!variantId) return;

            // Main product (always add)
            const items = [
                {
                    id: variantId,
                    quantity: 1
                }
            ];

            // Extra products
            if (productId === "4645461229622") {
                items.push(
                    { id: 12444576251963, quantity: 1 },
                    { id: 31708048031798, quantity: 1 },
                    { id: 13634558754875, quantity: 1 }
                );
            } else if (productId === "8762081378629") {
                items.push(
                    { id: 12444576251963, quantity: 1 },
                    { id: 31708048031798, quantity: 1 },
                    { id: 47443584713029, quantity: 1 }
                );
            }

            try {
                // Get current cart
                const cart = await fetch('/cart.js').then(res => res.json());

                // Existing variant IDs
                const existingVariantIds = cart.items.map(item => item.variant_id);

                // Always keep the main product
                const itemsToAdd = [items[0]];

                // Add only missing extra products
                for (let i = 1; i < items.length; i++) {
                    if (!existingVariantIds.includes(items[i].id)) {
                        itemsToAdd.push(items[i]);
                    }
                }

                // console.log("Items to add:", itemsToAdd);

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        items: itemsToAdd
                    })
                });

                if (!response.ok) {
                    throw new Error('Add to cart failed');
                }
                const isCartDrawerActive = (function () {
                    if (typeof window.isCartDrawerVariant === 'function') {
                        return window.isCartDrawerVariant();
                    }
                    // const urlParams = new URLSearchParams(window.location.search);
                    // const abCart = urlParams.get('ab_cart');
                    // const cartTest = urlParams.get('cart_test');
                    // return abCart === 'drawer' || cartTest === 'drawer';
                    return true;
                })();


                if (isCartDrawerActive && window.JJCartDrawerAB && typeof window.JJCartDrawerAB.open === 'function') {
                    document.body.classList.add('cart-drawer-ab');
                    const modal = document.getElementById('js-product-addtocart-modal');
                    if (modal) {
                        try { $(modal).modal('hide'); } catch (e) {}
                        modal.style.display = 'none';
                        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                        document.body.classList.remove('modal-open');
                    }
                    window.JJCartDrawerAB.open();
                    if (typeof window.JJCartDrawerAB.syncAndRefresh === 'function') {
                        window.JJCartDrawerAB.syncAndRefresh();
                    }
                    return;
                }
                // Redirect
                if (window.currentPath === "nl") {
                    window.location.href = "/nl/cart";
                } else if (window.currentPath === "de") {
                    window.location.href = "/de/cart";
                } else {
                    window.location.href = "/cart";
                }

            } catch (error) {
                console.error("Error adding to cart:", error);
            }

        });
    });
};

window.addCartFromPopup();